export default __webpack_public_path__ + "static/media/Img_NewFindYourJoy_02.9e0afae8.png";